import Section from "../layout/Section";
import Container from "../layout/Container";
import PropertyCard from "../ui/PropertyCard";

/* ================= DATA ================= */

const properties = [
  {
    id: "p1",
    title: "Rooftop Luxe Retreat",
    location: "Phoenix, AZ",
    images: [
      "https://res.cloudinary.com/dge0knh7q/image/upload/q_auto/f_auto/v1776444087/rooftop_retreat_nkipts.svg",
      "https://res.cloudinary.com/dge0knh7q/image/upload/q_auto/f_auto/v1776444086/rooftop_retreat_2_oewx14.svg",
      "https://res.cloudinary.com/dge0knh7q/image/upload/q_auto/f_auto/v1776444086/rooftop_retreat_3_atubgx.svg",
    ],
    beds: 3,
    baths: 3,
    sleeps: 6,
    badge: "Rooftop Views",
    featured: true,
  },
  {
    id: "p2",
    title: "Cozy Urban Suite",
    location: "Dallas, TX",
    images: [
      "https://res.cloudinary.com/dge0knh7q/image/upload/q_auto/f_auto/v1776444081/cozy_suit_giaizh.svg",
      "https://res.cloudinary.com/dge0knh7q/image/upload/q_auto/f_auto/v1776444081/cozy_suit_2_bjjhq1.svg",
    ],
    beds: 1,
    baths: 1,
    sleeps: 2,
    badge: "Cozy Stay",
  },
  {
    id: "p3",
    title: "Guest Nest",
    location: "Dallas, TX",
    images: [
      "https://res.cloudinary.com/dge0knh7q/image/upload/q_auto/f_auto/v1776444082/Guest_Nest_dldjxu.svg",
      "https://res.cloudinary.com/dge0knh7q/image/upload/q_auto/f_auto/v1776444081/Guest_Nest_2_gpu5wq.svg",
      "https://res.cloudinary.com/dge0knh7q/image/upload/q_auto/f_auto/v1776444081/Guest_Nest_3_cjduqu.svg",
    ],
    beds: 1,
    baths: 1,
    sleeps: 2,
    badge: "Private Stay",
  },
  {
    id: "p4",
    title: "Skyline Pool Suite",
    location: "Dallas, TX",
    images: [
      "https://res.cloudinary.com/dge0knh7q/image/upload/q_auto/f_auto/v1776444089/Skyline_stay_i6vc5i.svg",
      "https://res.cloudinary.com/dge0knh7q/image/upload/q_auto/f_auto/v1776444086/Skyline_stay_3_codbze.svg",
    ],
    beds: 1,
    baths: 1,
    sleeps: 2,
    badge: "Skyline Views",
  },
  {
    id: "p5",
    title: "Northern Haven",
    location: "Sudbury, ON",
    images: [
      "https://res.cloudinary.com/dge0knh7q/image/upload/q_auto/f_auto/v1776444084/Northern_Haven_ji2tnw.svg",
      "https://res.cloudinary.com/dge0knh7q/image/upload/q_auto/f_auto/v1776444079/Northern_Haven_2_chvduq.svg",
    ],
    beds: 5,
    baths: 4,
    sleeps: 10,
    badge: "Nature Escape",
  },
];

/* ================= COMPONENT ================= */

export default function PropertyGrid() {
  const featured = properties.find((p) => p.featured);
  const rest = properties.filter((p) => !p.featured);

  return (
    <Section background="bg-bg-surface" padding="lg">
      <Container>

        {/* HEADER */}
        <div className="max-w-content mb-10 md:mb-14">
          <span className="text-small font-semibold uppercase text-brand-primary">
            Our portfolio
          </span>

          <h3 className="mt-2 text-display font-extrabold text-text-primary">
            Homes we actively manage
          </h3>

          <p className="mt-3 text-body text-text-muted max-w-reading">
            A curated portfolio of high-performing properties across global destinations.
          </p>
        </div>

        {/* ================= MOBILE ================= */}
        <div className="
          md:hidden flex gap-4
          overflow-x-auto no-scrollbar
          pb-4 px-1
          snap-x snap-mandatory
        ">
          {properties.map((item) => (
            <div
              key={item.id}
              className="min-w-[85%] h-[240px] snap-start"
            >
              <PropertyCard {...item} />
            </div>
          ))}
        </div>

        {/* ================= DESKTOP ================= */}
        <div className="
          hidden md:grid
          grid-cols-2
          gap-6 lg:gap-8
          h-[520px] lg:h-[600px]
        ">

          {/* FEATURED */}
          <div className="h-full">
            <PropertyCard {...featured} variant="featured" />
          </div>

          {/* RIGHT GRID */}
          <div className="
            grid grid-cols-2 grid-rows-2
            gap-6 lg:gap-8
            h-full
          ">
            {rest.map((item) => (
              <div key={item.id} className="h-full">
                <PropertyCard {...item} />
              </div>
            ))}
          </div>

        </div>

      </Container>
    </Section>
  );
}